import React, {useState} from 'react';

import logo from "./assets/logo.webp";
import styles from './emdbComponent.module.less';

function EmdbComponent ({name}) {

  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className={styles.test}>
      <div className={styles.header}>
        <div className={styles.logo}><img src={logo}/></div>
        <div className={styles.main}>HEADER</div>
        <div id="header-cart" className={styles.cart}></div>
      </div>

      <p>Componente de {name}</p>
      {isLoading && <div>Cargando ...</div>}
    </div>
  );
}

export default EmdbComponent;